<footer class="py-7xl">
  <div class="px-lg md:px-6xl">
    <div
      class="top-section flex flex-col justify-between border-b border-neutral-300 mb-2xl">
      <div class="mb-2xl">
        <!-- Logo -->
        <div class="svg-container">
          <mars-logo />
        </div>

        <p class="text-neutral-500 text-small">
          {{ 'footer_section_contraa_slogan' | transloco }}
        </p>

        <div class="social-links py-xl mt-lg">
          <ul class="flex gap-md">
            @let social = branding.social();

            <!-- Facebook -->
            @if (social.facebook; as url) {
              <li>
                <a
                  [href]="url"
                  [attr.target]="isExternal(url) ? '_blank' : null"
                  [attr.rel]="isExternal(url) ? 'noopener noreferrer' : null"
                  aria-label="Facebook">
                  <mars-facebook-icon />
                </a>
              </li>
            }

            <!-- X -->
            @if (social.x; as url) {
              <li>
                <a
                  [href]="url"
                  [attr.target]="isExternal(url) ? '_blank' : null"
                  [attr.rel]="isExternal(url) ? 'noopener noreferrer' : null"
                  aria-label="X">
                  <mars-x-icon />
                </a>
              </li>
            }

            <!-- Instagram -->
            @if (social.instagram; as url) {
              <li>
                <a
                  [href]="url"
                  [attr.target]="isExternal(url) ? '_blank' : null"
                  [attr.rel]="isExternal(url) ? 'noopener noreferrer' : null"
                  aria-label="Instagram">
                  <mars-instagram-icon />
                </a>
              </li>
            }

            <!-- Linkedin -->
            @if (social.linkedin; as url) {
              <li>
                <a
                  [href]="url"
                  [attr.target]="isExternal(url) ? '_blank' : null"
                  [attr.rel]="isExternal(url) ? 'noopener noreferrer' : null"
                  aria-label="LinkedIn">
                  <mars-linkedin-icon />
                </a>
              </li>
            }

            <!-- Tiktok -->
            <li>
              <a href="#">
                <mars-tiktok-icon />
              </a>
            </li>

            <!-- Youtube -->
            <li>
              <a href="#">
                <mars-youtube-icon />
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div class="links mb-2xl">
        <a
          [routerLink]="'/' + (Path.ABOUT | navigation)"
          routerLinkActive="active-route"
          class="font-medium py-xs text-neutral-900 text-small"
          >{{ 'footer_section_about_link' | transloco }}</a
        >
        <a
          [routerLink]="'/' + (Path.BECOME_SUPPLIER | navigation)"
          routerLinkActive="active-route"
          class="font-medium py-xs text-neutral-900 text-small"
          >{{ 'footer_section_become_a_supplier_link' | transloco }}</a
        >
        <a
          [routerLink]="'/' + (Path.FEATURES | navigation)"
          routerLinkActive="active-route"
          class="font-medium py-xs text-neutral-900 text-small"
          >{{ 'footer_section_features_link' | transloco }}</a
        >
        <a
          [routerLink]="'/' + (Path.CONTACT_US | navigation)"
          routerLinkActive="active-route"
          class="font-medium py-xs text-neutral-900 text-small"
          >{{ 'footer_section_contact_us_link' | transloco }}</a
        >
      </div>
    </div>

    <div class="bottom-section flex flex-col justify-between gap-4xl">
      <div class="flex gap-lg">
        <a class="font-medium py-xs text-neutral-900 text-small" href="#">{{
          'footer_section_privacy_policy_link' | transloco
        }}</a>
        <a class="font-medium py-xs text-neutral-900 text-small" href="#">{{
          'footer_section_terms_conditions_link' | transloco
        }}</a>
      </div>
      <p class="py-xs text-neutral-700 text-extra-small">
        {{ 'footer_section_developed_by_link' | transloco }}
        <a
          class="font-semibold text-supplier-500"
          href="https://www.areebtechnology.com/"
          target="_blank"
          >Areeb Technology</a
        >
      </p>
    </div>
  </div>
</footer>
